/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Credit_Exhaustion_TitleInputs */

const en_credit_exhaustion_title = /** @type {(inputs: Credit_Exhaustion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've used all your AI actions this month`)
};

const de_credit_exhaustion_title = /** @type {(inputs: Credit_Exhaustion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine KI-Aktionen sind aufgebraucht`)
};

const fr_credit_exhaustion_title = /** @type {(inputs: Credit_Exhaustion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez utilise toutes vos actions IA`)
};

const es_credit_exhaustion_title = /** @type {(inputs: Credit_Exhaustion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has agotado todas tus acciones de IA`)
};

const it_credit_exhaustion_title = /** @type {(inputs: Credit_Exhaustion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai esaurito tutte le tue azioni IA`)
};

const nl_credit_exhaustion_title = /** @type {(inputs: Credit_Exhaustion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt al je AI-acties verbruikt`)
};

const pl_credit_exhaustion_title = /** @type {(inputs: Credit_Exhaustion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wykorzystales wszystkie swoje akcje AI`)
};

const fi_credit_exhaustion_title = /** @type {(inputs: Credit_Exhaustion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olet kayttanyt kaikki tekoalytoimintosi`)
};

const da_credit_exhaustion_title = /** @type {(inputs: Credit_Exhaustion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du har brugt alle dine AI-handlinger`)
};

const sv_credit_exhaustion_title = /** @type {(inputs: Credit_Exhaustion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du har anvaent alla dina AI-aatgaerder`)
};

/**
* | output |
* | --- |
* | "You've used all your AI actions this month" |
*
* @param {Credit_Exhaustion_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const credit_exhaustion_title = /** @type {((inputs?: Credit_Exhaustion_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credit_Exhaustion_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_credit_exhaustion_title(inputs)
	if (locale === "fr") return fr_credit_exhaustion_title(inputs)
	if (locale === "es") return es_credit_exhaustion_title(inputs)
	if (locale === "it") return it_credit_exhaustion_title(inputs)
	if (locale === "nl") return nl_credit_exhaustion_title(inputs)
	if (locale === "pl") return pl_credit_exhaustion_title(inputs)
	if (locale === "fi") return fi_credit_exhaustion_title(inputs)
	if (locale === "da") return da_credit_exhaustion_title(inputs)
	if (locale === "sv") return sv_credit_exhaustion_title(inputs)
	return en_credit_exhaustion_title(inputs)
});